import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { POSITIONS } from '../config/positions';
import { statsLeadersFiltersSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors/filters-selector';
import { UPDATE_FILTER_ITEM } from '../../../../../store/js/modules/statspro/stats-leaders/actions';
import { useTeamsForSeason } from '../../../../../../../common/react/hooks/use-teams-for-season';
import { statsLeadersNavSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors';
import { composeGetTranslation } from '../../../../../../../common/react/utils/translations';
import { SelectMultiple } from '../../../../../../../common/react/components/select-multiple';
import { SvgIcon } from '../../../../../../../common/react/components/SvgIcon';

const getTranslation = composeGetTranslation( 'label.statsLeaders.filters.' );

export const StatsLeadersFilters = () => {
    const dispatch = useDispatch();

    const filters = useSelector( statsLeadersFiltersSelector );
    const nav = useSelector( statsLeadersNavSelector );
    const teams = useTeamsForSeason( nav.season.id );

    const [ resetFns, setResetFns ] = useState( [] );
    
    const updateFilterItem = ( filterItem, value ) => {
        dispatch( UPDATE_FILTER_ITEM.request( { filterItem, value } ) );
    };

    const addOnResetCallback = resetFn => {
        setResetFns( fns => ( [ ...fns, resetFn ] ) );
    };

    return (
        <div className="stats-leaders-filters">
            <div className="stats-leaders-filters__item-wrapper">
                <SelectMultiple
                    // @ts-ignore
                    items={ POSITIONS }
                    getInitialSelectedItems={ () => POSITIONS.filter( p => filters.positions.includes( p.name ) ) }
                    label={ getTranslation( 'position' ) }
                    itemToString={ pos => pos.name }
                    onSelectedItemsChange={ pos => {
                        updateFilterItem( 'positions', pos.map( p => p.name ) );
                    } }
                    addOnResetCallback={ addOnResetCallback }
                    getItemText={ item => item.name }
                    getItemLabel={ item => item.name }
                />
            </div>
            <div className="stats-leaders-filters__item-wrapper">
                <SelectMultiple
                    items={ teams }
                    getInitialSelectedItems={ () => teams.filter( t => filters.teams.includes( t.providerId ) ) }
                    label={ getTranslation( 'team' ) }
                    itemToString={ team => team.name }
                    onSelectedItemsChange={ team => {
                        updateFilterItem( 'teams', team.map( t => t.providerId ) );
                    } }
                    addOnResetCallback={ addOnResetCallback }
                    getItemText={ item => item.name }
                    getItemLabel={ item => (
                        <span style={ {
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'space-between',
                            lineHeight: 1,
                            width: '100%'
                        } }>
                            <span style={ { marginRight: '1rem' } }>
                                { item.name }
                            </span>
                            <SvgIcon
                                icon={ `aflc-${ item.abbreviation.toLowerCase() }-flag` }
                                style={ { width: '3.1rem', maxHeight: '3rem' } }
                            />
                        </span>
                    ) }
                />
            </div>
            <div className="stats-leaders-filters__item-wrapper stats-leaders-filters__item-wrapper--reset">
                <button
                    className="stats-leaders-filter-reset-button"
                    onClick={ () => resetFns.forEach( func => func() ) }
                >
                    { getTranslation( 'resetButtonText' ) }
                </button>
            </div>
        </div>
    );
};
